module.exports = __webpack_public_path__ + "static/media/amazon-locker.2b63c332.png";